import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  searchButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.hover,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  searchIcon: {
    width: 20,
    height: 20,
    marginRight: theme.spacing(1),
  },
}))

export default styles
